export class Filter {
    id?: number
    codigo_condominio?: number
    codigo_unidade?: number
    codigo_cliente?: number
    data?: string
    ids?: number[]
    codigos_condominios?: number[]
    codigos_unidades?: number[]
    codigos_clientes?: number[]
    since?: string
    until?: string
}